import ConvolverReverbEffect from './ConvolverReverbEffect.js';
import Tone from 'tone';
import Effects from './Effects.js';

const DEFAULT_SAMPLE_ID = "QmQjRkKxSgAYtuepTdHp8inhYp8QYc18KUL5fYSprqKAEt";

class GuitarAmpEffect extends Effects.Effect {
    constructor(sequencerEngine, convolver)  {
        super("Guitar Amp", () => new Tone.Gain(1), sequencerEngine);

        this.convolver = convolver || new ConvolverReverbEffect(sequencerEngine);
        if (!convolver) {
            // then set the sample to the default sample
            this.convolver.setConvolverSample(DEFAULT_SAMPLE_ID);
        }
        this.convolver.wetParameter.set(1);
        this.effectNode.connect(this.convolver.effectNode);
        this.updateInitialValues();
    }

    dispose() {
        super.dispose();
        this.convolver.dispose();
    }

    disconnect(node) {
        this.convolver.disconnect(node);
    }

    connect(node) {
        this.convolver.connect(node);
    }

    getJson() {
        return {
            ... super.getJson(),
            convolver: this.convolver.getJson()
        };
            
    }

    async fromJson(json, isCopy) {
        super.fromJson(json, isCopy);
        await this.convolver.fromJson(json.convolver, isCopy);
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        console.log('get effect copy guitar amp');
        let copy = new GuitarAmpEffect(
            sequencerEngine,
            this.convolver.getEffectCopy(sequencerEngine, ignoreId));

        if (!ignoreId) {
            copy.id = this.id;
        }
        return copy;
    }
}

export default GuitarAmpEffect;
